<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2
      [titulo]      = "DAT_TITULOS.titulo"
      [modulo]      = "GLOBAL_TITULOS.modulo"
      [tituloCard]  = "DAT_TITULOS.tituloCardList"
      [innTemplate] = "enviarTemplateEdit"
      [innTemplateButton]="innTemplateButton">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->
  
    <!-- OPCIONES BOTONES IZQUIERDO -->
    <ng-template #innTemplateButton>
      <div class="col-md-6 mb-2">
        <div class="pagetitle">
          <div class="btn-group-justified btn-group" style="float: right;">
            <!-- <button (click)="nuevo()" class="btn btn-primary"> <i aria-hidden="true" class="fa fa-plus"></i> Agregar </button>-->
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <!-- ALERTAS -->
        <div class="alert alert-success" role="alert" *ngIf="this.tipoViajeSelected?.generaTicketGarita">
          Tipo de planificación habilitada para creación automatica de Ticket de Garita
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>

        <div class="alert alert-warning" role="alert" *ngIf="this.isCheckRecurrente">
          CHECK-REGISTRO RECURRENTE. Existen viajes finalizados con las mismas caracteristicas de: orden, buque y tanquero.
          Puede llenar el registro o seleccionar  - Guardar registro recurrente - Viaje referencia id: {{this.viajeReferencia?.viajeId}}
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>

        <div class="alert alert-warning" role="alert" *ngIf="this.isCheckRecurrente">
          GUARDAR: Valida y guarda respuestas nuevas para el viaje-planificación actual
          GUARDAR REGISTRO RECURRENTE: Almacena para el registro actual la copia del Registro Referencia
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
      </div>
    </ng-template>
    <!-- OPCIONES BOTONES IZQUIERDO -->
  
    <!-- GRILLA -->
    <ng-template #enviarTemplateEdit>
      <div class="form-group col-md-12" *ngIf="!isCreate">
          <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter "
              (keyup)="onQuickFilterChanged() " #quickFilter />
          <br>
          <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
          <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"  
                            [id]    ="DAT_AG_GRID.id" 
                            [class] ="DAT_AG_GRID.class" 
                            [ngStyle]="DAT_AG_GRID.style" 
                            [rowData]="rowData" 
                            [columnDefs]="columnDefs"
                            [pagination]="DAT_AG_GRID.pagination" 
                            [rowHeight]="DAT_AG_GRID.rowHeight"
                            [paginationPageSize]="DAT_AG_GRID.pagina"
                            [allowContextMenuWithControlKey]="true"
                            [frameworkComponents]="frameworkComponents" >
          </ag-grid-angular>
      </div>
    <!-- GRILLA -->

    <!-- Form en pantalla completa check garita-->
    <div class="container-fluid" *ngIf="isCreate">
      <div class="card border-warning mb-3" >
        <div class="card-body" *ngIf="rowData">
          <h5 class="card-title" style="font-size: medium; ">Viaje #  {{ selected?.idViaje }}</h5>
            <div class="row">
              <div class="col" style="font-size: smaller;">Proveedor: {{ selected?.proveedorNombre }} </div>
              <div class="col" style="font-size: smaller;">Placa: {{ selected?.placa }}  </div>
            </div>
            <div class="row">
              <div class="col" style="font-size: smaller;">Contenedor: {{ selected?.furgon }} </div>
              <div class="col" style="font-size: smaller;">Chofer: {{ selected?.choferNombre }} (Cédula: {{ selected?.choferCedula }})</div>
            </div>
          </div>
      </div>

      <div class="col-md-2 mt-3"><span class="badge text-bg-success">{{selected?.estado}}</span></div><br>
      <strong>Llenar Check Garita | Hora Inicio Proceso : </strong> {{fechaHoraInicio}} 
      <hr>
      
      <form [formGroup]="formulario" mat-dialog-content>
        <div class="form-check form-switch col-md-6 ms-md-auto align-middle" *ngIf="vistaOperador">
          <input class="form-check-input" id="all" type="checkbox" [formControl]="checkTodos">
          <label class="form-check-label" for="all">MARCAR TODO SI</label>
        </div>
          <!-- CHECK FIJO MODELO FIJO / REGISTRO A -->
          <div *ngIf="this.selected?.tipoCarga == 1">
            <div class="row p-2" *ngFor="let opcion of listOpciones">
              <div class="row col"><label for="{{ opcion.name }}"><span>{{ opcion.valor }}</span></label></div>
              <div class="col input-group input-group-lg">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="{{ opcion.name }}" id="inline1_{{opcion.name}}" value="Si" [formControlName]="opcion.name">
                  <label class="form-check-label" for="inline1_{{opcion.name}}">SI</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="{{ opcion.name }}" id="inline2_{{opcion.name}}" value="No" [formControlName]="opcion.name">
                  <label class="form-check-label" for="inline2_{{opcion.name}}">NO</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" name="{{ opcion.name }}" id="inline3_{{opcion.name}}" value="NA" [formControlName]="opcion.name">
                  <label class="form-check-label" for="inline3_{{opcion.name}}">NA</label>
                </div>
              </div>
            </div>
          </div>
          <hr>

          <!-- CHECK DINAMICO -->
          <app-check-dinamico *ngIf="preguntasDinamicas.length > 0"
            [preguntas]="preguntasDinamicas" 
            [parentForm]="formulario">
          </app-check-dinamico>

        <!-- COMUNES -->
        <div class="row">
          <div class="col-6 form-group" *ngIf="this.selected?.tipoCarga == 1 ">
            <app-lfsa-input formControlName="guardiaNombre" [label]="'* Nombre del guardia'" [id]="'guardiaNombre'" [control]="formulario.get('guardiaNombre')" [type]="'text'" >
            </app-lfsa-input>
          </div>

          <div class="col-3 form-group" *ngIf="this.selected?.tipoCarga == 1 ">
            <app-lfsa-input formControlName="guardiaCedula" [label]="'* Cédula del guardia'" [id]="'guardiaCedula'" [control]="formulario.get('guardiaCedula')" [type]="'text'" >
            </app-lfsa-input>
          </div>

          <div class="row">
            <div class="col-12 form-group" *ngIf="!isView">
              <label>Firma Requerida</label>
                <canvas #canvas class="border-warning" (touchstart)="startDrawing($event)" (touchmove)="moved($event)" height="200" width="600" >
                </canvas>
                <p class="error-message" *ngIf="signatureNeeded">Firma es requerida</p>
                <button (click)="clearPad()" class="btn btn-primary"> <i aria-hidden="true" class="fa fa-refresh"></i> Limpiar </button>
            </div>
            
            <div class="col-12 form-group" *ngIf="isView">
              <img [src]="urlFirma" class="rounded mx-auto d-block" alt="Firma Garita">
              <p *ngIf="this.selected?.tipoCarga == 1">GUARDIA: {{formulario.get('guardiaNombre').value}} - CEDULA: {{formulario.get('guardiaCedula').value}}</p>
            </div>
          </div>

        </div>

        <div class="row mt-3" *ngIf="this.selected?.tipoCarga == 1 || this.tipoViajeSelected?.generaTicketGarita">
          <div class="col form-group">
              <app-lfsa-input formControlName="observacion" [label]="'* Observacion'" [id]="'observacion'" [control]="formulario.get('observacion')" 
              [type]="'text'">
              </app-lfsa-input>
              <label *ngIf="this.tipoViajeSelected?.generaTicketGarita">Observaciones relacionados con la creación del ticket de aut. ingreso a garita (opcional)</label>
          </div>

          <div class="col form-group" *ngIf="this.tipoViajeSelected?.generaTicketGarita">
              <app-lfsa-input formControlName="garitaTicket" [label]="'*Número de Ticket Garita'" [id]="'garitaTicket'" [control]="formulario.get('garitaTicket')" 
              [placeholder]="'Número ticket'"  [type]="'number'" class="form-control-sm" [isReadOnly]="true">
              </app-lfsa-input>
          </div>

          <div class="col form-group" *ngIf="selected?.tipoCarga == 2 || this.tipoViajeSelected?.tipoEscenario == 'COMPRA'">
            <label for="estado">Autorización Check</label>
            <select class="form-control form-select" formControlName="estado" id="estado" name="estado" 
            [class.is-invalid]="formulario.get('estado')?.invalid && formulario.get('estado')?.touched">
              <!--31032026 Cristhian ya no va a GARITA REVISADA ahora a REVISION ACEPTADA-->
              <option value="" selected disabled>-- Seleccione --</option>
              <option value="REVISION_ACEPTADA" >Revisión aceptada</option>
              <option value="REVISION_RECHAZADA">Revisión rechazada</option>
            </select>
            <small *ngIf="formulario.controls['estado'].errors && formulario.controls['estado'].touched" class="text-danger">*Este campo es inválido</small>
            <small *ngIf="formulario.controls['estado']?.hasError('required') && formulario.controls['estado'].touched" class="text-danger">*Este campo es requerido</small>
          </div>
        </div>

        <div class="row mt-3" *ngIf="this.selected?.tipoCarga == 2 || this.tipoViajeSelected?.generaTicketGarita || this.tipoViajeSelected?.tipoEscenario == 'COMPRA'">
          <div class="col">
            <label>GARITA : {{ garitaUsuario?.desca }} </label>
          </div>
          <div class="col">
            <label>FECHA ENTRADA : {{ this.formAprobacion.get('fechaEntrada').value }} </label>
          </div>
        </div><hr>

        <app-lfsa-botones-formulario 
            (devolverAccion) = " acciones( $event )" 
            [formularioValido] =" formulario.invalid"
            [mostrarBotonVerde] = " vistaOperador && !isAprobador"
            [loading]="loading" [textBoton]="'Guardar'" class="m-1">
        </app-lfsa-botones-formulario>
        
        <div class="text-center p-2" *ngIf="this.isCheckRecurrente">
            <button (click)="acciones('MODEL_RECURRENTE')" class="btn btn-primary col-4"> 
            <i aria-hidden="true" class="fa fa-plus"></i> Guardar registro recurrente</button>
        </div>

      </form>
    </div>

    </ng-template>
  </div>
  
  <!-- MODAL 
  <app-lfsa-modal [innTemplate] = "abrirModal" [classModal] = "'modal-dialog modal-lg'" [idButton] = "'abrirModal'" [idClose] = "'cerrarModal'" [titulo] = "titleModal">
  </app-lfsa-modal>
    
  <ng-template #abrirModal>
    <div class="container-fluid">
      <div class="card border-warning mb-3" >
        <div class="card-body" *ngIf="rowData">
          <h5 class="card-title" style="font-size: medium; ">Viaje #  {{ selected?.idViaje }}</h5>
            <div class="row">
              <div class="col" style="font-size: smaller;">Proveedor: {{ selected?.proveedorNombre }} </div>
              <div class="col" style="font-size: smaller;">Placa: {{ selected?.placa }}  </div>
            </div>
          </div>
      </div>
      <div class="col-md-2"><span class="badge text-bg-success">{{selected?.estado}}</span></div><br> 
      <h5>Llenar Check Garita </h5><hr>
      <h6> Hora Inicio Proceso: {{fechaHoraInicio}} </h6><hr>

      <form [formGroup]="formulario" mat-dialog-content>
        <div class="form-check form-switch col-md-6 ms-md-auto align-middle">
          <input class="form-check-input" id="all" type="checkbox" [formControl]="checkTodos">
          <label class="form-check-label" for="all">MARCAR TODO SI</label>
        </div>

        <div class="row p-2" *ngFor="let opcion of listOpciones">
          <div class="row col"><label for="{{ opcion.name }}"><span>{{ opcion.valor }}</span></label></div>
          <div class="col input-group input-group-lg">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="{{ opcion.name }}" id="inline1_{{opcion.name}}" value="Si" [formControlName]="opcion.name">
              <label class="form-check-label" for="inline1_{{opcion.name}}">SI</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="{{ opcion.name }}" id="inline2_{{opcion.name}}" value="No" [formControlName]="opcion.name">
              <label class="form-check-label" for="inline2_{{opcion.name}}">NO</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" name="{{ opcion.name }}" id="inline3_{{opcion.name}}" value="NA" [formControlName]="opcion.name">
              <label class="form-check-label" for="inline3_{{opcion.name}}">NA</label>
            </div>
          </div>
        </div>
        <hr>

        <div class="row">
          <div class="col-6 form-group">
            <app-lfsa-input formControlName="guardiaNombre" [label]="'* Nombre del guardia'" [id]="'guardiaNombre'" [control]="formulario.get('guardiaNombre')" [type]="'text'" >
            </app-lfsa-input>
          </div>

          <div class="col-3 form-group">
            <app-lfsa-input formControlName="guardiaCedula" [label]="'* Cédula del guardia'" [id]="'guardiaCedula'" [control]="formulario.get('guardiaCedula')" [type]="'text'" >
            </app-lfsa-input>
          </div>

          <div class="col-3 form-group">
            <label></label>
            <div class="form-check form-switch">
              <input class="form-check-input" formControlName="firma" id="firma" type="checkbox">
              <label class="form-check-label" for="firma">Firmar</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col form-group">
              <app-lfsa-input formControlName="observacion" [label]="'* Observacion'" [id]="'observacion'" [control]="formulario.get('observacion')" 
              [type]="'text'">
              </app-lfsa-input>
          </div>

          <div class="mb-3">
            <label for="formFileMultiple" class="form-label form-control-sm">Seleccione Imagenes</label>
            <input class="form-control" type="file" id="formFileMultiple" multiple>
          </div>
        </div>
        
        <app-lfsa-botones-formulario 
            (devolverAccion) ="acciones( $event )" 
            [formularioValido] ="formulario.invalid"
            [mostrarBotonVerde] = "isCreate && !isAprobador" 
            [loading]="loading" [textBoton]="'Guardar'" class="row p-3">
        </app-lfsa-botones-formulario>
      </form>

    </div>
  </ng-template>-->
  <!-- END MODAL --> 


    <!-- MODAL DATOS BALANZA-->
    <app-lfsa-modal [innTemplate]="abrirModal2" [classModal]="'modal-dialog modal-lg'" [idButton]="'fillOne'"  [idOpen]="'Modal2'"
                    [idClose]="'cerrarModal2'" [titulo]="'Datos de Ticket de Garita ' + this.titleModal" ></app-lfsa-modal>
    <ng-template #abrirModal2>
        <div class="container-fluid">
          <div class="card border-warning mb-3" >
            <div class="card-body" *ngIf="rowData">
              <h5 class="card-title" style="font-size: medium; ">Viaje #  {{ selected?.idViaje }}</h5>
                <div class="row">
                  <div class="col" style="font-size: smaller;">Proveedor: {{ selected?.proveedorNombre }} </div>
                  <div class="col" style="font-size: smaller;">Placa: {{ selected?.placa }}  </div>
                </div>
                <div class="row">
                  <div class="col" style="font-size: smaller;">Contenedor: {{ selected?.furgon }}  </div>
                  <div class="col" style="font-size: smaller;">Chofer: {{ selected?.choferNombre }} (Cédula: {{ selected?.choferCedula }})  </div>
                </div>
              </div>
          </div>
          <div class="col-md-2"><span class="badge text-bg-success">{{selected?.estado}}</span></div><br> 
          <h5>Información del Ticket de Ingreso a Garita </h5><hr>
          <h6> Hora Inicio Proceso: {{fechaHoraInicio}} </h6><hr>

            <!-- FORMULARIO DE BALANZA -->
            <form [formGroup]="formAprobacion" novalidate class="form-group"> 
                <div class="row">
                    <div class="col">
                        <app-lfsa-input formControlName="garitaTicket" [label]="'*Número de Ticket Garita'" [id]="'garitaTicket'" [control]="formAprobacion.get('garitaTicket')" 
                        [placeholder]="'Ingrese número ticket'" (change)="getTicketGarita();" [type]="'number'" class="form-control-sm" [isReadOnly]="isCreate">
                        </app-lfsa-input>
                    </div>
                    <div class="col">
                        <app-lfsa-input formControlName="garitaNombre" [label]="'* Garita'" [id]="'garitaNombre'" [control]="formAprobacion.get('garitaNombre')" 
                            [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                        </app-lfsa-input>
                    </div>
                    <!-- DESCONTNUA FUNCIONALIDAD EN APROBACIÓN DE GARITA, SE VUELVE AUTOMATICO DESDE LA REVISIÓN VEHICULAR, 
                     MEJORA SOLICITADA POR CRISTHIAN 
                    <div class="col" *ngIf="tipoViajeSelected?.generaTicketGarita">
                      <label> </label>
                      <button (click)="generarTGarita()" class="btn btn-block btn-primary"> <i aria-hidden="true" class="fa fa-plus"></i>  GENERAR TICKET GARITA </button>
                    </div>
                    -->
                </div>

                <div class="row">
                    <div class="col">
                        <app-lfsa-input formControlName="fechaEntrada" [label]="'Fecha entrada de vehículo'" [id]="'fechaEntrada'" [control]="formAprobacion.get('fechaEntrada')" 
                            [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                        </app-lfsa-input>
                    </div>
                    <div class="col">
                        <app-lfsa-input formControlName="fechaSalida" [label]="'Fecha salida de vehículo'" [id]="'fechaSalida'" [control]="formAprobacion.get('fechaSalida')" 
                            [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                        </app-lfsa-input>
                    </div>
                    <div class="col form-group">
                        <label for="estado">Proceso de Garita</label>
                        <select class="form-control form-select" formControlName="estado" aria-label="Disabled">
                          <option value="GARITA_REVISADA">Garita Revisada</option>
                          <option value="GARITA_APROBADO">Garita Aprobada</option>
                          <option value="FINALIZADO">Autorizar Salida</option>
                        </select>
                        <small *ngIf="formAprobacion.controls['estado'].errors && formAprobacion.controls['estado'].touched" class="text-danger">*Este campo es inválido</small>
                    </div>
                </div>

              <app-lfsa-botones-formulario 
                  (devolverAccion) ="acciones($event)" 
                  [formularioValido] ="formAprobacion.invalid" 
                  [loading]="loading" [textBoton]="'Aprobar'" class="row p-3">
              </app-lfsa-botones-formulario>
            </form>
        </div>
    </ng-template>
    <!-- END MODAL -->
